import loadsAnalytics from "./loadsAnalytics";
import sendsEvents from "./sendsEvents";

const hasSource = (state) => ({
  source: state.source,
  setSource: (source) => {
    state.source = source;
  },
});

const Analytics = (config, env, logger, source) => {
  const state = {
    siteAnalyticsSet: false,
    trackers: [],
    eventQueue: [],
    source,
  };
  return Object.assign(
    {},
    hasSource(state),
    loadsAnalytics(config, state, env, logger),
    sendsEvents(config, state, logger)
  );
};

export default Analytics;
